import { css } from '@emotion/react'

import { size } from '@twisto/styles'

export const articleList = css`
  margin: 0;
  padding: 0;
  list-style: none;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(18rem, 1fr));
  gap: clamp(${size[12]}, 1vw + ${size[8]}, ${size[16]});
  margin-top: clamp(${size[20]}, 1vw + ${size[16]}, ${size[24]});
`

export const linkIcon = css`
  font-size: 1em;
`
